import * as yup from 'yup';
import { ERROR_TEXT } from '@utils/validators/text';
import { PATTERN } from '@utils/validators/pattern';

const nhisCareerSchema = yup.object({
  provider: yup.string(),
  name: yup.string().required('').matches(PATTERN.NAME, ERROR_TEXT.NAME_PATTERN),
  birthDay: yup.string().required(''),
  phone: yup.string().required('').matches(PATTERN.CELLPHONE, ERROR_TEXT.MOBILE_PATTERN),
});

export default nhisCareerSchema;
